import React, { useState, ChangeEvent, FormEvent } from 'react';
import Button from '../UI/button';

interface CommentInputProps {
  onSubmit: (commentText: string) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
}

const CommentInput: React.FC<CommentInputProps> = ({
  onSubmit,
  placeholder = 'Add a comment...',
  disabled = false,
  maxLength = 1000
}) => {
  const [commentText, setCommentText] = useState('');

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      setCommentText(value);
    }
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmedText = commentText.trim();
    if (trimmedText && !disabled) {
      onSubmit(trimmedText);
      setCommentText('');
    }
  };

  const isSubmitDisabled = disabled || commentText.trim().length === 0;
  const characterCount = commentText.length;
  const isApproachingLimit = characterCount > 800;

  return (
    <form
      className='comment-input'
      onSubmit={handleSubmit}
    >
      <div className='comment-input__wrapper'>
        <div className='comment-input__header'>
          <span
            className={`comment-input__counter ${
              isApproachingLimit ? 'comment-input__counter--warning' : ''
            }`}
          >
            {characterCount}/{maxLength}
          </span>
        </div>
        <textarea
          className='comment-input__textarea'
          value={commentText}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          rows={3}
          maxLength={maxLength}
        />
        <div className='comment-input__footer'>
          <Button
            type='submit'
            variant='primary'
            disabled={isSubmitDisabled}
            className='comment-input__submit-btn'
          >
            Send
          </Button>
        </div>
      </div>
    </form>
  );
};

export default CommentInput;
